import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const expenseTypeLocaleModule: LocaleModule = {
  name: "expenseType",
  messages: { en: en, it: it },
};
